import { useEffect } from "react";

const useBeforeUnload = callback => {
	useEffect ( () => {
		const handleBeforeUnload = () => {
			// Perform the callback function
			callback ();
		};

		window.addEventListener ( "beforeunload", handleBeforeUnload );

		return () => {
			window.removeEventListener ( "beforeunload", handleBeforeUnload );
		};
	}, [ callback ] );
};

export default useBeforeUnload;
